import React, {  } from 'react';
import {Field, ErrorMessage } from 'formik';
import  {Box, } from '@mui/material/';
import {Alert} from '@mui/material/';


function RadioButton(props) {

    const { label, name, optionObject, ...rest } = props.symptom
    return (
        <Box  className="radioboxContainer">
        <label> {label} </label>
        <Field  name={name} {...rest}>
{({field }) => {
         return optionObject.map( (option) =>{
            return (
                <React.Fragment key = {option.key}>
                    <p className="checkboxItem">
                    <input
                    type = "radio"
                    id =  {`${name}${option.value}`}
                    {...field}
                    value = {option.value}
                    checked = {field.value===(option.value)}
                    onClick={props.onClick}
                    />
                <label htmlFor = {option.value}> {option.key} </label>
                </p>
                </React.Fragment>
                )
            })
        }}
       </Field>
       <ErrorMessage name={name} >
            {errorMsg => <Alert severity='error' >{errorMsg}</Alert>}
          </ErrorMessage>
        </Box>
     
     );
}

export default RadioButton;